const ACTIONS = {
  UPDATE_STATE: 'UPDATE_STATE',
  RESET_STATE: 'RESET_STATE',
  GO_STEP: 'GO_STEP',
};

export default ACTIONS;
